module.exports = __webpack_public_path__ + "img/Vinjeboka_Pentakel.8679bdca.jpg";